import { createFileRoute, Outlet } from "@tanstack/solid-router";

export const Route = createFileRoute("/_dashboard/dashboard/bank-accounts")({
  staticData: {
    breadcrumb: "Bank Accounts",
  },
  component: () => <Outlet />,
});
